import React, { useContext } from 'react';
import * as Env from 'widget/env';

interface MsgContext {
  msg: Env.Message;
}

const MsgContext = React.createContext<MsgContext>({} as MsgContext);

export const useMsgContext = () => useContext(MsgContext);
export default MsgContext;
